export default "__VITE_PUBLIC_ASSET__adf62aea__"